const PREV_PAGE_TYPE = {
  SHIRYO: 'SHIRYO',
  OC: 'OC',
  COMPARE_LIST: 'COMPARE_LIST',
  COMPARE: 'COMPARE',
  OTHER: 'OTHER',
  RETURN_PAGE: 'RETURN_PAGE',
};

export class PrevPageType {
  type: string;

  constructor(prevPageType: string) {
    this.type = prevPageType;
  }

  isShiryo(): boolean {
    return this.type === PREV_PAGE_TYPE.SHIRYO;
  }

  isOc(): boolean {
    return this.type === PREV_PAGE_TYPE.OC;
  }

  // 比較選択画面
  isCompareList(): boolean {
    return this.type === PREV_PAGE_TYPE.COMPARE_LIST;
  }

  // 比較画面
  isCompare(): boolean {
    return this.type === PREV_PAGE_TYPE.COMPARE;
  }

  isOrganic(): boolean {
    return this.type !== PREV_PAGE_TYPE.SHIRYO && this.type !== PREV_PAGE_TYPE.OC;
  }

  isReturnPage(): boolean {
    return this.type === PREV_PAGE_TYPE.RETURN_PAGE;
  }

  /**
   * 遷移元の画面タイプから、遷移先の画面URLを生成するメソッド
   * @param {Boolean} isSp UAがSPかどうかを判定するフラグ
   * @param {String} queryParams 追加のクエリパラメータ
   * @param {String} referrer リファラ
   * @returns 遷移先の画面URLを返す
   */
  getUrlAfterCheckPrevPage(isSp: boolean = true, queryParams: string = '', referrer: string = ''): string {
    const urlPrefix = isSp ? '/smp2' : '/net2';
    switch (this.type) {
      case PREV_PAGE_TYPE.SHIRYO:
        return isSp ? `${urlPrefix}/shiryoSeikyu/entry/restoreSelect/` : `${urlPrefix}/shiryoSeikyu/entry/select/`;
      case PREV_PAGE_TYPE.OC:
        return `${urlPrefix}/openCampus/reserveEntry/select/`;
      case PREV_PAGE_TYPE.COMPARE:
        // 比較画面はsp画面しかないためsmp2固定
        return `/smp2/quipMember/compare/compare?${queryParams}`;
      case PREV_PAGE_TYPE.COMPARE_LIST:
        // 比較選択画面はsp画面しかないためsmp2固定
        return `/smp2/quipMember/compare/list?${queryParams}`;
      case PREV_PAGE_TYPE.RETURN_PAGE:
        return referrer;
      default:
        return isSp ? '/smp/' : '/';
    }
  }
}
